import type { SVGProps } from "react";
import * as React from "react";
const SvgMeta = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
    />
    <path
      fill="#0081FB"
      d="M4.16 14.233c0 .804.168 1.422.387 1.796.287.49.716.697 1.152.697.564 0 1.08-.147 2.072-1.595.796-1.16 1.734-2.789 2.364-3.81l1.069-1.73c.742-1.2 1.6-2.536 2.585-3.442C14.595 5.41 15.462 5 16.334 5c1.465 0 2.861.895 3.93 2.574C21.432 9.412 22 11.727 22 14.117c0 1.42-.266 2.464-.718 3.289-.436.797-1.288 1.594-2.72 1.594v-2.274c1.226 0 1.532-1.187 1.532-2.546 0-1.937-.428-4.086-1.372-5.621-.67-1.09-1.538-1.755-2.493-1.755-1.032 0-1.864.82-2.798 2.285-.496.777-1.006 1.725-1.578 2.794l-.63 1.177c-1.266 2.365-1.587 2.904-2.22 3.793C7.893 18.41 6.946 19 5.7 19c-1.479 0-2.414-.675-2.994-1.692C2.232 16.478 2 15.39 2 14.15l2.16.082Z"
    />
    <path
      fill="url(#Meta_svg__a)"
      d="M3.703 7.734C4.693 6.125 6.123 5 7.763 5c.949 0 1.892.296 2.878 1.144 1.078.927 2.227 2.454 3.66 4.97l.514.904c1.241 2.178 1.947 3.299 2.36 3.827.532.679.904.881 1.387.881 1.226 0 1.532-1.187 1.532-2.546L22 14.117c0 1.42-.266 2.464-.718 3.289-.436.797-1.288 1.594-2.72 1.594-.89 0-1.679-.204-2.551-1.07-.67-.666-1.454-1.849-2.057-2.912l-1.794-3.157c-.9-1.585-1.726-2.767-2.203-3.302-.514-.575-1.175-1.27-2.23-1.27-.853 0-1.578.631-2.184 1.597l-1.84-1.152Z"
    />
    <path
      fill="url(#Meta_svg__b)"
      d="M7.728 7.29c-.854 0-1.579.63-2.185 1.596-.858 1.364-1.383 3.396-1.383 5.347 0 .804.168 1.422.387 1.796l-1.842 1.279C2.232 16.478 2 15.39 2 14.15c0-2.254.587-4.603 1.703-6.417C4.693 6.125 6.123 5 7.763 5l-.035 2.29Z"
    />
    <defs>
      <linearGradient
        id="Meta_svg__a"
        x1={6.243}
        x2={20.017}
        y1={13.576}
        y2={14.236}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0064E1" />
        <stop offset={0.4} stopColor="#0064E1" />
        <stop offset={0.83} stopColor="#0073EE" />
        <stop offset={1} stopColor="#0082FB" />
      </linearGradient>
      <linearGradient
        id="Meta_svg__b"
        x1={5.13}
        x2={5.13}
        y1={15.188}
        y2={9.838}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0082FB" />
        <stop offset={1} stopColor="#0064E0" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgMeta;
